import { Link, useLocation } from "react-router-dom";
import { Pencil, LogOut, Plus, User, FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSacredAdmin } from "@/hooks/useSacredAdmin";
import { clearEditorAuth } from "@/lib/sacred-library/sacred-library-api";

/**
 * Shown site-wide when a sacred editor/admin/staff is logged in.
 */
export function SacredStaffBar() {
  const { editorUser, isAdmin, canEditLibrary, canEditPages, refresh } = useSacredAdmin();
  const location = useLocation();

  if (!editorUser) {
    const onLibrary = location.pathname.startsWith("/library");
    if (!onLibrary) return null;
    return (
      <div
        className="bg-amber-50 border-b border-amber-200 text-amber-950 text-sm py-2 px-4"
        data-testid="sacred-staff-login-hint"
      >
        <span className="mr-2">Staff editor?</span>
        <Link to="/sacred-admin.html" className="font-medium underline">
          Sign in
        </Link>
      </div>
    );
  }

  const logout = () => {
    clearEditorAuth();
    refresh();
    window.location.href = "/library";
  };

  return (
    <div
      className="bg-primary/10 border-b border-primary/20 text-sm py-2 px-4 flex flex-wrap items-center gap-3"
      data-testid="sacred-staff-bar"
    >
      <span className="inline-flex items-center gap-1 font-medium">
        <User className="w-4 h-4" />
        {editorUser.email}
        <span className="text-muted-foreground font-normal">({editorUser.role})</span>
      </span>
      {canEditPages && (
        <Link to="/admin/pages" className="inline-flex items-center gap-1 hover:underline font-medium">
          <FileText className="w-4 h-4" /> Pages CMS
        </Link>
      )}
      {canEditLibrary && (
        <>
          <Link to="/library" className="hover:underline">
            Sacred Library
          </Link>
          <Link to="/library?create=1" className="inline-flex items-center gap-1 hover:underline">
            <Plus className="w-4 h-4" /> New library topic
          </Link>
        </>
      )}
      {isAdmin && (
        <Link to="/sacred-admin.html" className="hover:underline text-xs">
          Users & setup
        </Link>
      )}
      <Button type="button" variant="ghost" size="sm" className="h-7 ml-auto" onClick={logout}>
        <LogOut className="w-4 h-4 mr-1" /> Logout
      </Button>
    </div>
  );
}
